module.exports = __webpack_public_path__ + "media/images/smart_phone/btn_demo_aichi_off-17c18aa9dec5f6d8d61f4293982a4062.png";